module.exports = __webpack_public_path__ + "img/instagram.09c66596.svg";